import * as React from 'react';

import IconWithPopover from 'components/icon-with-popover/IconWithPopover';

import { getPriceRecommendationRange } from 'utils/helper/price';
import { __t, applyTranslations } from 'utils/language';

import './tile-standard-content-details-price-reco.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

import type { PriceRecoItem } from 'utils/influencers';

type Props = {
  priceInfo: Array<PriceRecoItem>,
  isBlocked?: boolean
};

const ICONS = {
  instagram_post: 'instagram-custom-fg',
  instagram_story: 'story-custom-fg',
  instagram_reel: 'reel-custom-fg',
  youtube_video: 'youtube-custom-fg',
  tiktok_video: 'tiktok-custom-fg'
};

const TileStandardContentDetailsPriceReco = (
  {
    priceInfo,
    isBlocked
  }: Props
): JSX.Element => (
  <div className="tile-standard-content-details-price-reco__container">
    {
      priceInfo.map(recoEntry => {
        const priceRange = getPriceRecommendationRange(recoEntry.minPrice ?? NaN, recoEntry.maxPrice ?? NaN);
        const blurredPriceRange = 'xxx-xxx';
        const updatedPriceRange = isBlocked ? blurredPriceRange : priceRange;

        return (
          <div
            key={recoEntry.type}
            className="tile-standard-content-details-price-reco"
          >
            <IconWithPopover
              name={ICONS[recoEntry.type]}
              width={14}
              height={14}
              customColor="grey"
              label={__t(`collabary_common.types.${recoEntry.type}.singular`)}
            />
            <span>{updatedPriceRange}</span>
          </div>
        );
      })
    }
  </div>
);

export default TileStandardContentDetailsPriceReco;
